/**
 * @copyright @2024 Dream Team Cell C. All rights reserved.
 * @description Page to define the Breakpoints.
 * --------------------------------------------------------------------
 * Creation Details
 * @author Naishad Vaishnav
 * Date Created: 24/Apr/2024
 * Test Case Ref:
 */

// ----------------------------------------------------------------------

/* Constants */

const breakpoints = {
  values: {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1920,
    laptop: 1280
  }
};

export default breakpoints;
